import data from "./auth.mjs";
//#region src/locales/en/server/index.ts
var server_default = { auth: data };
//#endregion
export { server_default as default };
